export default __webpack_public_path__ + "static/media/bgThree.28c082e4.jpg";